import axios from '@/api.js';
import 'babel-polyfill';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import '../../../static/css/style.css';
import privacyPolicy from './privacyPolicy.vue';

Vue.use(ElementUI)


Vue.prototype.axios = axios


/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(privacyPolicy)
})



// WEBPACK FOOTER //
// ./src/views/privacyPolicy/privacyPolicy.js